<template>
<div class="vueCalendrierReservation">
    <img  v-if="etape <= 7" src='https://preprod.api.defipix.fr/logos/logo_bg_white.png' alt="logo defipix" class="logoDP">
    <transition name="bounce" mode="out-in">
        <FormDateLieu key="1" v-if="etape == 1" />
        <SelectBooth key="2" v-if="etape == 2" />
        <FormMailTel key="3" v-if="etape == 3" />
        <SelectDelivery key="4" v-if="etape == 4" />
        <SelectOptions key="5" v-if="etape == 5" />
        <FormFinal key="6" v-if="etape == 6" />
        <Recapitulatif key="7" v-if="etape == 7" />
        <Merci key="8" v-if="etape == 8" :from="'RC'" />
    </transition>
</div>
</template>

<script>
import FormDateLieu from '@/components/OrderBooth/Event' //etape 1
import SelectBooth from '@/components/OrderBooth/Booth' //etape 2
import FormMailTel from '@/components/OrderBooth/Contact' //etape 3
import SelectDelivery from '@/components/OrderBooth/Delivery' //etape 4
import SelectOptions from '@/components/OrderBooth/Options' //etape 5
import FormFinal from '@/components/OrderBooth/Form' //etape 6
import Recapitulatif from '@/components/OrderBooth/Order' //etape 7
import Merci from '@/components/Merci' //etape 8


export default {
    title: 'Défipix.fr | Commander un photobooth',
    computed: {
        etape: function() {
            return this.$store.getters.reservation_client.etape;
        },
    },
    components: {
        FormDateLieu,
        SelectBooth,
        FormMailTel,
        SelectDelivery,
        SelectOptions,
        FormFinal,
        Recapitulatif,
        Merci
    }
}
</script>

<style>
.logoDP {
    max-width: 12em;
    margin: auto;
    display: block;
}

.vueCalendrierReservation {
    max-width: 82em;
    width: 90%;
    margin: auto;  
}

.button {
    background-color: #f677c4;
    color: white;
    padding: 10px;
    border-radius: 5px;
    border: none;
    font-weight: 500;
}

.titre {
    color: #fff !important;
    text-align: center;
    padding: 0 1em 1em;
    flex-basis: 100%;
}

.bounce-enter-active {
  animation: bounce-in .2s;
}
.bounce-leave-active {
  animation: bounce-in .2s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/router/OrderBooth.vue